import clientTranslations from "@src/modules/client/_langs/fr-CA";
import importTranslations from "@src/modules/member/components/import/_langs/fr-CA";
import dashboardTranslations from "@src/modules/member/modules/main/dashboard/_langs/fr-CA";
import { mcpConsentFrCA } from "@src/modules/member/modules/main/mcp-consent/_langs/fr-CA";
import { mcpFrCA } from "@src/modules/member/modules/settings/integrations/_langs/mcp/fr-CA";
import { mcpConnectionsFrCA } from "@src/modules/member/modules/settings/profile/_langs/mcp-connections/fr-CA";
import { rayaLucariaFrCA } from "@src/raya-lucaria/i18n";
import { geoFrCA } from "@src/raya-lucaria/utils/geo-i18n-fr-CA";

export default {
  "Delete Item": "Supprimer l'élément",
  countries: geoFrCA.countries,
  states: geoFrCA.states,
  wizard: {
    stepPosition: "Étape {{current}} sur {{total}} : {{label}}",
    stepName: "Étape {{n}} sur {{total}}, {{label}}",
    stepNameCompleted: "Étape {{n}} sur {{total}}, {{label}}, terminée",
    stepNameSkipped: "Étape {{n}} sur {{total}}, {{label}}, ignorée",
    next: "Suivant",
    nextTo: "Suivant : {{step}}",
    backTo: "Retour à {{step}}",
    continueTo: "Continuer vers {{step}}",
    blocked_one: "1 problème à cette étape. Corrigez-le pour continuer.",
    blocked_other:
      "{{count}} problèmes à cette étape. Corrigez-les pour continuer.",
    blockedUnknown:
      "Cette étape comporte des problèmes. Corrigez-les pour continuer.",
    opensInNewTab: "(s'ouvre dans un nouvel onglet)",
  },
  controls: {
    combobox: {
      selectAll: "Tout sélectionner",
      deselectAll: "Tout désélectionner",
      clear: "Effacer",
      selected: "{{count}} sélectionné(s)",
      more: "+{{count}} de plus",
      showLess: "Afficher moins",
      empty: "Aucun résultat",
      searchPlaceholder: "Rechercher…",
      create: "Créer",
      unavailable: "Indisponible",
      loading: "Chargement…",
      clearAll: "Effacer toutes les sélections",
      removeOption: "Retirer {{label}}",
      optionRemoved: "Option retirée : {{label}}",
      selectionCleared: "Sélection effacée",
      resultOne: "1 résultat disponible",
      resultMany: "{{count}} résultats disponibles",
      createOption: "Créer « {{label}} », nouvelle entrée",
      created: "Option créée et sélectionnée : {{label}}",
    },
  },
  language: "fr-CA",
  twoFaCodeCopied: "Copié",
  dismissNotification: "Fermer la notification",
  notificationsRegion: "Notifications",
  languageWord: "Français",
  discard: "Abandonner",
  saveImage: "Enregistrer l'image",
  cropImageFailed:
    "Désolé, cette image n'a pas pu être préparée pour le téléversement. Réessayez ou choisissez une image plus petite.",
  cropArea: "Zone de rognage",
  cropAreaInstructions:
    "Utilisez les touches fléchées pour déplacer l'image, Maj pour des pas plus grands, plus et moins pour zoomer.",
  cropMoveLeft: "Déplacer à gauche",
  cropMoveRight: "Déplacer à droite",
  cropMoveUp: "Déplacer vers le haut",
  cropMoveDown: "Déplacer vers le bas",
  cropZoom: "Zoom",
  cropZoomValue: "{{percent}} pour cent",
  cropZoomAnnouncement: "Zoom {{percent}} pour cent. {{position}}",
  cropImageCentred: "Image centrée",
  cropPositionOne: "Image {{first}} par rapport au centre",
  cropPositionTwo: "Image {{first}} et {{second}} par rapport au centre",
  cropOffsetLeft: "{{percent}} pour cent vers la gauche",
  cropOffsetRight: "{{percent}} pour cent vers la droite",
  cropOffsetUp: "{{percent}} pour cent vers le haut",
  cropOffsetDown: "{{percent}} pour cent vers le bas",
  cropProfileImage: "Rogner la photo de profil",
  cropOrganizationImage: "Rogner l'image de l'organisation",
  cropInvoiceLogo: "Rogner le logo de la facture",
  cropImageDescription:
    "Faites glisser l'image pour la déplacer, ou utilisez les touches fléchées ou les boutons Déplacer. Utilisez la roulette de la souris, les touches plus et moins ou le curseur Zoom pour zoomer.",
  download: "Télécharger",
  settings: "Paramètres",
  accountMenu: "Menu du compte et de l'organisation",
  tryAgain: "Réessayer",
  accountMenuFor: "Menu du compte et de l'organisation : {{organization}}",
  currentOrganizationIs: "Organisation actuelle : {{organization}}",
  switchedToOrganization: "Organisation changée : {{organization}}.",
  switchOrganization: "Changer d'organisation",
  switchOrganizationMessage:
    "Sélectionnez l'organisation vers laquelle vous souhaitez basculer.",
  switchOrganizationTo: "Basculer vers l'organisation {{organization}}",
  copyPaymentLink: "Copier le lien de paiement",
  copyPaymentLinkUnavailable:
    "Disponible lorsque Stripe est connecté comme passerelle de paiement",
  paymentLinkCopied: "Lien de paiement copié",
  send: "Envoyer",
  invoiceNumber: "Numéro de facture",
  invoiceActions: "Actions de la facture",
  processingFee: "Frais de traitement",
  payNow: "Payer {{amount}} maintenant",
  help: {
    label: "Aide",
    opensInNewTab: "(s'ouvre dans un nouvel onglet)",
  },
  poweredBy: "Propulsé par",
  invoiceAlreadyPaid: "Facture déjà payée",
  paymentProcessorNotSupported: "Processeur de paiement non pris en charge",
  clientM: clientTranslations,
  member: {
    mcpConsent: mcpConsentFrCA,
    components: {
      slackConnectionBanner: {
        connectMessage:
          "Connectez votre espace de travail Slack pour utiliser Invup dans Slack.",
        connectCta: "Connecter Slack",
        reconnectMessage:
          "Invup doit se reconnecter rapidement pour ajouter de nouvelles fonctionnalités Slack.",
        reconnectCta: "Reconnecter Slack",
        missingScopes: "Autorisations manquantes : {{scopes}}",
        reportsConnectConsequence:
          "Connectez Slack pour livrer les abonnements aux rapports dans un canal.",
        reportsReconnectConsequence:
          "Les abonnements aux rapports ne peuvent pas être livrés tant que Slack n'est pas reconnecté.",
        notConnectedAskAdmin:
          "Slack n'est pas connecté, donc les abonnements aux rapports ne peuvent pas être livrés. Demandez à un administrateur de connecter Slack.",
        needsReconnectAskAdmin:
          "Slack doit être reconnecté avant que les abonnements aux rapports puissent être livrés. Demandez à un administrateur de reconnecter Slack.",
        statusLoadError:
          "Désolé, l'état de Slack n'a pas pu être chargé en raison d'une erreur de notre côté. Veuillez réessayer plus tard.",
        retryCta: "Réessayer",
        installError:
          "Désolé, Slack n'a pas pu être connecté en raison d'une erreur de notre côté. Veuillez réessayer plus tard.",
      },
    },
    import: importTranslations,
    main: {
      dashboard: dashboardTranslations,
      fees: {
        taxRowLabel: "la taxe {{name}}",
        surchargeRowLabel: "le supplément {{name}}",
      },
      projects: {
        rowLabel: "le projet {{name}}",
        removeService: "Retirer {{name}}",
        serviceMemberCount_one: "membre",
        serviceMemberCount_other: "membres",
      },
      auth: {
        passwordResetSuccess:
          "Votre mot de passe a été réinitialisé avec succès.",
        passwordResetSuccessTitle: "Mot de passe réinitialisé",
        passwordResetContinue: "Continuer",
      },
      contracts: {
        rowLabel: "le contrat {{number}}",
        contracts: "Contrats",
        newContract: "Nouveau contrat",
        columns: {
          title: "Titre",
          contractNumber: "N° de contrat",
          status: "Statut",
          signers: "Signataires",
          updated: "Mis à jour",
          actions: "Actions",
        },
        status: {
          draft: "Brouillon",
          sent: "Envoyé",
          partially_signed: "Signé en partie",
          executed: "Exécuté",
          voided: "Annulé",
        },
        type: {
          signature_only: "Signature seulement",
          client_agreement: "Entente client",
          client_contract: "Contrat client",
        },
        promote: {
          prompt: "Ce contrat n’a pas de facturation.",
          action: "Configurer",
          title: "Ajouter la facturation",
          description:
            "Ajoutez ce dont la facturation a besoin. Une fois ajoutée, la facturation ne peut pas être retirée.",
          clientRequired: "Sélectionnez un client.",
          currencyRequired: "Sélectionnez une devise.",
          submit: "Ajouter la facturation",
          cancel: "Annuler",
          failed: "Impossible d’ajouter la facturation. Veuillez réessayer.",
        },
        rowActions: {
          menuLabel: "Actions du contrat",
          view: "Afficher",
          send: "Envoyer pour signature",
          resend: "Renvoyer pour signature",
          downloadSealed: "Télécharger la copie scellée",
          downloadCertificate: "Télécharger le certificat",
          delete: "Supprimer",
        },
        empty: {
          title: "Aucun contrat pour le moment",
          subtitle:
            "Envoyez un PDF finalisé pour signature électronique — Invup suit chaque signataire et scelle la copie exécutée.",
        },
        modal: {
          title: "Nouveau contrat",
          subtitle:
            "Choisissez son type, ajoutez le document, puis remplissez ce que ce type exige.",
        },
        create: {
          stepsLabel: "Étapes",
          stepType: "Type",
          stepDocument: "Document",
          stepDetails: "Détails",
          stepCompleted: "terminée",
          typeLegend: "De quel type de contrat s’agit-il?",
          types: {
            signatureOnly: {
              label: "Signature seulement",
              description:
                "Un document à faire signer. Aucun client associé, aucune facturation.",
            },
            clientAgreement: {
              label: "Entente client",
              description:
                "Associée à un client, sans aucune transaction financière.",
            },
            clientContract: {
              label: "Contrat client",
              description: "Associé à un client et génère des factures.",
            },
          },
          typeRequired: "Choisissez un type de contrat.",
          documentHeading: "Ajoutez le document",
          documentHelp:
            "Téléversez le fichier PDF ou Word finalisé que les gens signeront.",
          documentHelpWithTitle:
            "Téléversez le fichier PDF ou Word finalisé, puis donnez un titre au contrat.",
          document: "Document",
          documentPlaceholder: "Choisissez un fichier ou glissez-le ici",
          documentHint: "PDF ou DOCX · jusqu’à {{size}} Mo",
          documentRequired: "Téléversez un document PDF ou Word.",
          uploadInProgress:
            "Attendez la fin du téléversement avant de continuer.",
          detailsHeading: "Détails du contrat",
          detailsHelpAgreement:
            "Une entente client exige un titre et le client auquel elle est associée.",
          detailsHelpContract:
            "Un contrat client exige un titre, un client et une devise. Vous ajouterez ensuite les postes dans l’onglet Facturation.",
          contractTitle: "Titre du contrat",
          contractTitlePlaceholder: "p. ex. Contrat-cadre de services",
          titleRequired: "Saisissez un titre de contrat.",
          client: "Client",
          clientHintAgreement: "Le client auquel cette entente est associée.",
          clientRequired: "Choisissez un client.",
          clientsLoading: "Chargement des clients...",
          clientsLoadFailedTitle: "Impossible de charger les clients",
          clientsLoadFailed:
            "Désolé, la liste des clients n’a pas pu être chargée en raison d’une erreur de notre côté. Veuillez réessayer.",
          clientsForbiddenTitle: "Vous ne pouvez pas voir les clients",
          clientsForbidden:
            "Votre rôle ne permet pas de voir la liste des clients. Demandez l’accès à un administrateur de l’organisation, ou choisissez plutôt le type Signature seulement.",
          tryAgain: "Réessayer",
          currencyRequired: "Choisissez une devise.",
          noClientsTitle: "Aucun client pour le moment",
          noClientsBody:
            "Ce type de contrat est associé à un client. Ajoutez un client dans le nouvel onglet, puis choisissez Vérifier de nouveau pour le sélectionner ici.",
          noClientsBodyNoPermission:
            "Ce type de contrat est associé à un client, mais votre rôle ne permet pas d’ajouter des clients. Demandez à un administrateur de l’organisation d’en ajouter un, ou choisissez plutôt le type Signature seulement.",
          addClient: "Ajouter un client",
          addClientAccessible:
            "Ajouter un client (s’ouvre dans un nouvel onglet)",
          checkAgain: "Vérifier de nouveau",
          clientsUpdated: "Liste des clients mise à jour.",
          stillNoClients: "Toujours aucun client.",
          changeType: "Changer de type",
          back: "Retour",
          next: "Suivant",
          submit: "Créer le contrat",
          submitting: "Création du contrat en cours...",
          failedTitle: "Ce contrat n’a pas pu être créé",
          failedServer:
            "Désolé, ce contrat n’a pas pu être créé en raison d’une erreur de notre côté. Veuillez réessayer.",
          created: "Contrat créé avec succès",
          createdBilling:
            "Ajoutez les postes et l’échéancier de paiement dans l’onglet Facturation.",
          createdDocument:
            "Ajoutez les signataires et placez leurs champs sur le document.",
          openBilling: "Ouvrir la facturation",
          openContract: "Ouvrir le contrat",
        },
        send: {
          title: "Envoyer pour signature",
          subtitle:
            "Chaque signataire reçoit son propre lien privé pour signer.",
          ownInbox: "boîte personnelle",
          sharedInbox: "boîte partagée",
          roleTitle: "Les boîtes partagées ne peuvent pas signer",
          roleBody:
            "Chaque signataire doit être une personne nommée avec sa propre boîte de réception. Remplacez les adresses partagées comme billing@ ou info@ avant l’envoi.",
          incompleteTitle: "Envoi impossible",
          warningsTitle: "À vérifier avant l’envoi",
          cancel: "Annuler",
          send: "Envoyer",
          sendFailed:
            "Désolé, ce contrat n’a pas pu être envoyé en raison d’une erreur de notre côté. Veuillez réessayer plus tard.",
          successTitle: "Envoyé pour signature",
          successBodyOne:
            "Envoyé à {{count}} signataire — ce contrat est maintenant verrouillé.",
          successBodyOther:
            "Envoyé à {{count}} signataires — ce contrat est maintenant verrouillé.",
          sentLocked: "envoyé · verrouillé",
        },
        resend: {
          title: "Renvoyer pour signature",
          confirm: "Renvoyer",
          confirmAll:
            "Renvoyer le lien de signature à tous ceux qui n’ont pas encore signé ?",
          confirmSigner: "Renvoyer le lien de signature à {{name}} ?",
          resendAll: "Tout renvoyer",
        },
        editor: {
          back: "Retour aux contrats",
          send: "Envoyer",
          signers: "Signataires",
          fields: "Champs",
          selectedField: "Champ sélectionné",
          addSigner: "Ajouter un signataire",
          addSignerFirst: "Ajoutez un signataire avant de placer des champs.",
          cancel: "Annuler",
          add: "Ajouter",
          fieldsHint:
            "Ajoutez un champ, puis glissez-le à sa place et assignez un signataire.",
          inspectorEmpty:
            "Sélectionnez un champ sur la page pour modifier son type, sa page et son signataire.",
          type: "Type",
          pageLabel: "Page",
          assignTo: "Assigner à un signataire",
          removeField: "Retirer le champ",
          removeSigner: "Retirer le signataire",
          resendSigner: "Renvoyer à ce signataire",
          signed: "Signé",
          namePlaceholder: "p. ex. Priya Natarajan",
          emailPlaceholder: "nom@entreprise.com",
          signerForbidden:
            "Vous n’avez pas la permission d’ajouter ce signataire.",
          signerSaveFailed:
            "Désolé, ce signataire n’a pas pu être ajouté en raison d’une erreur de notre côté. Veuillez réessayer plus tard.",
          nameLabel: "Nom",
          emailLabel: "Courriel",
          signerContacts: {
            pickerLabel: "Choisir parmi les contacts de {{client}}",
            pickerPlaceholder: "Rechercher un contact",
            sharedInbox: "Boîte partagée",
            orByHand: "Ou saisir une autre personne",
            noContacts:
              "{{client}} n’a encore aucun contact. Saisissez le signataire ci-dessous.",
            loadFailed:
              "Désolé, les contacts de {{client}} n’ont pas pu être chargés en raison d’une erreur de notre côté. Saisissez le signataire ci-dessous.",
            notOnList:
              "Cette adresse ne figure pas dans la liste de contacts de {{client}}.",
            saveToClient: "Enregistrer dans les contacts",
            dontSave: "Ne pas enregistrer",
            saved: "Contact enregistré avec succès",
            dismissNotice: "Fermer",
          },
          zoomIn: "Agrandir",
          zoomOut: "Réduire",
          hintTitle: "Presque prêt à envoyer",
          hintBody:
            "Ajoutez un signataire et placez au moins un champ avant l’envoi.",
          unassigned: "Non assigné",
          notFound: "Contrat introuvable.",
          pdfError: "Impossible de charger l’aperçu du document.",
          pdfNoText:
            "Ce document ne contient aucun texte qui peut être recherché ou lu à voix haute.",
          pdfTextUnavailable:
            "Nous n’avons pas pu lire le texte de ce document, il ne peut donc pas être recherché ni lu à voix haute.",
          pdfDownload: "Télécharger le contrat (PDF)",
          pageOfTotal: "Page {{page}} de {{total}}",
          zoomLevel: "Zoom à {{percent}} pour cent",
          zoomMin: "Zoom minimal, {{percent}} pour cent",
          zoomMax: "Zoom maximal, {{percent}} pour cent",
          fieldTypes: {
            signature: "Signature",
            initial: "Paraphe",
            date: "Date",
          },
        },
        executed: {
          executedOn: "Exécuté",
          headTitle: "Ce contrat est exécuté",
          headSub:
            "Tous les signataires ont signé. Le document est scellé et verrouillé — aucune modification possible.",
          details: "Registre d’exécution",
          contractNo: "Nº de contrat",
          signers: "Signataires",
          signedOn: "signé",
          fingerprint: "Empreinte du document",
          fingerprintHint: "SHA-256 du PDF/A scellé",
          timestamp: "Horodatage de confiance",
          timestampHint: "Scellé et horodaté · RFC 3161",
          downloadSealed: "Télécharger la copie scellée",
          downloadCertificate: "Télécharger le certificat",
          verifyTitle: "Vérifier l’intégrité",
          verifySub:
            "Déposez le fichier scellé pour confirmer qu’il n’a pas changé depuis l’exécution. Rien n’est téléversé — le fichier est haché et comparé.",
          drop: "Déposez le PDF scellé ici",
          dropHint: "ou cliquez pour choisir · rehaché avec le registre",
          verifying: "Vérification…",
          matchTitle: "Ce fichier correspond au registre scellé",
          matchBody:
            "Le SHA-256 de ce fichier est identique à l’empreinte enregistrée. Il n’a pas été modifié depuis l’exécution.",
          mismatchTitle:
            "Ce fichier ne correspond pas — il a peut-être été modifié",
          mismatchBody:
            "Le SHA-256 de ce fichier diffère de l’empreinte enregistrée. Téléchargez une nouvelle copie scellée ci-dessus.",
          checkAnother: "Vérifier un autre fichier",
        },
        billing: {
          tabsLabel: "Sections du contrat",
          tabDocument: "Document",
          tabBilling: "Facturation",
          sectionTitle: "Conditions du contrat",
          lineItems: "Postes",
          client: "Client",
          clientHint:
            "Les factures émises à partir de ce contrat sont facturées à ce client.",
          clientPlaceholder: "Sélectionnez un client...",
          currency: "Devise",
          currencyPlaceholder: "Sélectionnez une devise...",
          currencyHint:
            "Les postes et les paiements planifiés utilisent tous cette devise.",
          leadTime: "Délai d'émission",
          lockedNote:
            "Ce contrat a été envoyé : le client et la devise sont verrouillés. Le délai de facturation peut encore être modifié.",
          executedNote:
            "Ce contrat est entièrement signé : le client et la devise sont verrouillés. Le délai de facturation peut encore être modifié et s'applique aux factures qui ne sont pas encore générées.",
          voidedNote:
            "Ce contrat est annulé : ses conditions de facturation sont en lecture seule.",
          leadTimeInherit_one:
            "Valeur par défaut de l’organisation — {{count}}",
          leadTimeInherit_other:
            "Valeur par défaut de l’organisation — {{count}}",
          leadTimeUnit_one: "jour",
          leadTimeUnit_other: "jours",
          leadTimeDays_one: "{{count}} jour",
          leadTimeDays_other: "{{count}} jours",
          leadTimeOrgDefault_one:
            "La valeur par défaut de votre organisation est de {{count}} jour.",
          leadTimeOrgDefault_other:
            "La valeur par défaut de votre organisation est de {{count}} jours.",
          leadTimeOverride: "Personnaliser",
          leadTimeUseDefault: "Valeur par défaut",
          leadTimeHelp:
            "Les factures sont émises ce nombre de jours avant l’échéance du paiement. Toute modification met à jour la date d’émission de chaque facture non encore générée.",
          leadTimeHelpReadOnly:
            "Les factures sont émises ce nombre de jours avant l’échéance du paiement.",
          leadTimeRange:
            "Saisissez un nombre entier de jours entre {{min}} et {{max}}.",
          currencyChangeTitle: "Changer la devise",
          currencyChangeBody:
            "Changer la devise réétiquette chaque poste et chaque paiement planifié de ce contrat. Les montants restent les mêmes — seule la devise change.",
          currencyChangeConfirm: "Changer la devise",
          columns: {
            sku: "UGS",
            name: "Description",
            quantity: "Qté",
            unitPrice: "Prix unitaire",
            amount: "Montant",
          },
          addItem: "Ajouter un poste",
          addDisabledTooltip:
            "Définissez une devise sur ce contrat avant d’ajouter des postes.",
          itemNamePlaceholder: "Nom du poste",
          itemDescriptionPlaceholder: "Description",
          itemNameRequired:
            "Saisissez un nom de poste d’au plus 100 caractères.",
          itemSkuTooLong: "Saisissez une UGS d’au plus 100 caractères.",
          itemDescriptionTooLong:
            "Saisissez une description d’au plus 5 000 caractères.",
          itemQuantityInvalid: "Saisissez une quantité supérieure à zéro.",
          itemUnitPriceInvalid: "Saisissez un prix unitaire de zéro ou plus.",
          totalLabel: "Total",
          discardItem: "Abandonner cette ligne",
          removeItem: "Supprimer le poste",
          removeItemTitle: "Supprimer le poste",
          removeItemBody: "Voulez-vous vraiment supprimer « {{name}} » ?",
          rowMenuLabel: "Actions du poste",
          catalog: {
            addFromCatalog: "Ajouter depuis le catalogue",
            title: "Ajouter depuis le catalogue",
            searchLabel: "Rechercher dans le catalogue",
            searchPlaceholder: "Rechercher par nom ou UGS",
            selectedHeading_one: "{{count}} produit sélectionné",
            selectedHeading_other: "{{count}} produits sélectionnés",
            removeSelected: "Retirer {{name}} de la sélection",
            addProducts: "Ajouter des produits",
            addSelected_one: "Ajouter {{count}} produit",
            addSelected_other: "Ajouter {{count}} produits",
            wrongCurrency:
              "Tarifé en {{currency}} : impossible de l’ajouter à ce contrat.",
            selectionLimit:
              "Vous pouvez ajouter jusqu’à {{count}} produits à la fois.",
            empty:
              "Votre catalogue est vide. Ajoutez des produits dans les paramètres pour les choisir ici.",
            noResults: "Aucun produit actif ne correspond à cette recherche.",
            loadFailed: "Nous n’avons pas pu charger votre catalogue",
            loadFailedBody:
              "Désolé, l’erreur vient de chez nous. Réessayez dans un instant.",
            adding: "Ajout au contrat en cours.",
            added_one: "{{count}} produit ajouté",
            added_other: "{{count}} produits ajoutés",
            addedMessage:
              "Chacun devient un poste que vous pouvez modifier sans toucher à votre catalogue.",
            addFailed:
              "Nous n’avons pas pu ajouter ces produits. Réessayez dans un instant.",
            productUnavailable_one:
              "Un produit choisi n’est plus disponible. Nous l’avons retiré de votre sélection.",
            productUnavailable_other:
              "{{count}} produits choisis ne sont plus disponibles. Nous les avons retirés de votre sélection.",
          },
          empty: {
            noCurrencyTitle: "Définissez d’abord une devise",
            noCurrencyBody:
              "Un contrat doit avoir une devise avant de pouvoir contenir des postes. Définissez-en une ci-dessus pour commencer à chiffrer ce contrat.",
            setCurrency: "Définir une devise",
            noItemsTitle: "Aucun poste pour l’instant",
            noItemsBody:
              "La valeur du contrat est la somme de ses postes. Ajoutez le premier pour commencer.",
          },
          itemsLoadFailed: "Impossible de charger les postes",
          itemsLoadFailedBody:
            "Désolé, l’erreur vient de notre côté. Réessayez dans un instant.",
          retry: "Réessayer",
          saveFailed:
            "Désolé, cette modification n’a pas pu être enregistrée en raison d’une erreur de notre côté. Veuillez réessayer plus tard.",
          schedule: {
            title: "Calendrier de paiement",
            columns: {
              description: "Description",
              due: "Échéance",
              invoice: "Facture",
              amount: "Montant",
            },
            scheduledTotal: "Planifié",
            remainder:
              "Il reste {{remaining}} à planifier sur une valeur de contrat de {{value}}.",
            overScheduled:
              "Le calendrier totalise {{scheduled}}, soit plus que la valeur du contrat de {{value}}.",
            valueUnknown:
              "Les montants en pourcentage ne peuvent être calculés tant que la valeur du contrat est inconnue.",
            dueOnSigning: "À la signature",
            dueAfterSigning_one: "{{count}} jour après la signature",
            dueAfterSigning_other: "{{count}} jours après la signature",
            dueOnDate: "Le {{date}}",
            invoiceSameDay: "Facture émise le jour de l’échéance",
            invoiceEarlier_one: "Facture émise {{count}} jour avant",
            invoiceEarlier_other: "Facture émise {{count}} jours avant",
            datesOnceSigned: "Dates exactes une fois signé",
            issuedAndDue: "Émise le {{issued}} · échéance {{due}}",
            generatedOn: "Facture créée le {{at}}",
            warnDueOnArrival:
              "Cette facture sera émise le jour de son échéance : le client la recevra déjà échue.",
            warnShortenedWindow_one:
              "La facture sera émise à la date de signature : le client disposera de {{count}} jour, et non de {{lead}}.",
            warnShortenedWindow_other:
              "La facture sera émise à la date de signature : le client disposera de {{count}} jours, et non de {{lead}}.",
            leadLabel: "Envoyer la facture avant l’échéance",
            leadInherit_one: "Utiliser la valeur du contrat — {{count}} jour",
            leadInherit_other:
              "Utiliser la valeur du contrat — {{count}} jours",
            leadOverride: "Définir un délai personnalisé",
            leadUseDefault: "Utiliser la valeur du contrat",
            leadHelp:
              "La facture est émise ce nombre de jours avant l’échéance, puis reportée au jour ouvrable suivant.",
            addPayment: "Ajouter un paiement",
            addDisabledNoClient:
              "Ajoutez un client à ce contrat avant de planifier des paiements.",
            addDisabledNoCurrency:
              "Définissez une devise sur ce contrat avant de planifier des paiements.",
            addDisabledNoClientOrCurrency:
              "Ajoutez un client et définissez une devise avant de planifier des paiements.",
            addDisabledVoided:
              "Ce contrat est annulé; son calendrier est en lecture seule.",
            addDisabledFullyScheduled:
              "La totalité de la valeur du contrat est déjà planifiée. Augmentez la valeur du contrat ou modifiez un paiement pour libérer de la place.",
            fieldDescription: "Description",
            fieldDescriptionPlaceholder: "Acompte...",
            fieldTrigger: "Échéance du paiement",
            triggerAfterSigning: "Un nombre de jours après la signature",
            triggerFixedDate: "À une date fixe",
            fieldOffsetDays: "Jours après la signature",
            offsetHelp:
              "Entrez 0 pour un paiement dû à la date de signature. Le jour est la seule unité : trois mois correspondent à 90 jours.",
            fieldFixedDueDate: "Date d’échéance",
            fieldAmountType: "Type de montant",
            amountTypeFixed: "Un montant fixe",
            amountTypePercentage: "Un pourcentage de la valeur du contrat",
            fieldAmount: "Montant",
            fieldPercentage: "Pourcentage",
            percentageLivePreview:
              "Cela représente {{amount}} aujourd’hui. Le montant sera figé lors de la génération de la facture.",
            percentageLocksOnSave:
              "La valeur actuelle s’affichera une fois ce paiement enregistré.",
            percentageNoValue:
              "La valeur du contrat n’est pas encore connue; ce montant ne peut être calculé.",
            fieldAutoSend: "Envoyer automatiquement cette facture au client",
            autoSendHelp:
              "La facture sera envoyée par courriel au client à sa date d’émission, sans autre validation.",
            save: "Enregistrer le paiement",
            cancelAction: "Annuler",
            descriptionRequired:
              "Entrez une description d’au plus 255 caractères.",
            amountInvalid: "Entrez un montant supérieur à zéro.",
            percentageInvalid: "Entrez un pourcentage entre 0 et 100.",
            dueDateRequired: "Choisissez une date d’échéance.",
            saveFailed:
              "Désolé, ce paiement n’a pas pu être enregistré en raison d’une erreur de notre côté. Veuillez réessayer plus tard.",
            statusGenerated: "Facturé",
            statusCancelled: "Annulé",
            autoSendBadge: "Envoi automatique par courriel",
            lockedIn: "Figé lors de la création de la facture.",
            locksOnGenerate: "Sera figé lors de la génération de la facture.",
            rowMenuLabel: "Actions du paiement planifié",
            viewInvoice: "Voir la facture",
            edit: "Modifier le paiement",
            generate: "Générer maintenant",
            cancelPayment: "Annuler le paiement",
            deletePayment: "Supprimer le paiement",
            menuNotExecuted:
              "Disponible une fois que tous les signataires ont signé.",
            menuAlreadyInvoiced: "Ce paiement a déjà été facturé.",
            menuCancelled: "Ce paiement est annulé.",
            menuVoided: "Ce contrat est annulé.",
            menuNoInvoiceYet: "Aucune facture n’a encore été créée.",
            cancelBody:
              "Voulez-vous vraiment annuler ce paiement planifié? Il cessera de compter dans le calendrier et aucune facture ne sera créée.",
            deleteBody: "Voulez-vous vraiment supprimer ce paiement planifié?",
            generateTitle: "Générer la facture",
            generateSubtitle:
              "Vérifiez ces informations avant la création de la facture.",
            generateAmount: "Montant",
            generateClient: "Client",
            generateDueDate: "Échéance de la facture",
            generateDelivery: "Envoi",
            generateWillEmail:
              "Cette facture sera envoyée par courriel au client.",
            generateWillNotEmail:
              "Cette facture ne sera pas envoyée par courriel. Vous pourrez l’envoyer depuis la facture.",
            generateFailed:
              "Désolé, cette facture n’a pas pu être générée en raison d’une erreur de notre côté. Veuillez réessayer plus tard.",
            emptyTitle: "Aucun paiement planifié",
            emptyBody:
              "Ajoutez le premier pour indiquer quand ce contrat sera facturé. Invup crée les factures à l’avance pour vous.",
            blockedBodyNoClient:
              "Un paiement planifié a besoin d’un client à facturer.",
            blockedBodyNoCurrency:
              "Un paiement planifié a besoin d’une devise de facturation.",
            blockedBodyNeither:
              "Un paiement planifié a besoin d’un client à facturer et d’une devise de facturation.",
            loadFailed: "Impossible de charger le calendrier de paiement",
            loadFailedBody:
              "Désolé, l’erreur vient de notre côté. Réessayez dans un instant.",
          },
          burndown: {
            title: "Progression de la facturation",
            value: "Valeur du contrat",
            scheduled: "Planifié",
            unscheduled: "Non planifié",
            invoiced: "Facturé",
            paid: "Payé",
            outstanding: "Solde impayé",
            overScheduled: "Dépasse la valeur du contrat",
            emptyTitle: "Rien à facturer pour l’instant",
            emptyBody:
              "La progression de la facturation s’affichera une fois que ce contrat aura une devise et une valeur.",
            unavailableTitle: "Progression indisponible",
            unavailableBody:
              "Un élément de ce contrat est dans une devise différente : la progression de la facturation ne peut pas être calculée. D’autres sections peuvent tout de même afficher les montants qu’elles arrivent à totaliser. Communiquez avec le soutien pour le faire corriger.",
            loadFailed:
              "Impossible de charger la progression de la facturation",
            loadFailedBody:
              "Désolé, l’erreur vient de notre côté. Réessayez dans un instant.",
            meter: {
              paid: "Payé",
              outstanding: "Solde dû",
              share: "({{percent}} %)",
              shareUnderOne: "(< 1 %)",
              shareOverNinetyNine: "(> 99 %)",
              total: "sur {{amount}} facturé",
              nothingInvoiced:
                "Rien n’a encore été facturé. Cette barre se remplit à mesure que les factures sont émises selon l’échéancier.",
              settled: "Tout ce qui a été facturé est payé.",
              overpaid: "{{amount}} de plus a été payé que facturé.",
            },
          },
          invoices: {
            title: "Factures générées",
            columns: {
              invoice: "Facture",
              issued: "Date d’émission",
              due: "Échéance",
              amount: "Montant",
              status: "Statut",
            },
            statusDraft: "Brouillon",
            statusSent: "Envoyée",
            statusPaid: "Payée",
            partiallyPaid: "{{amount}} payé",
            emptyTitle: "Aucune facture pour l’instant",
            emptyBodyPending:
              "Les factures apparaîtront ici une fois que tous les signataires auront signé et qu’un paiement planifié arrivera à échéance.",
            emptyBodyExecuted:
              "Les factures apparaîtront ici à mesure que les paiements planifiés arriveront à échéance.",
            emptyBodyVoided:
              "Ce contrat est annulé : aucune autre facture ne sera émise.",
            loadFailed: "Impossible de charger les factures générées",
            loadFailedBody:
              "Désolé, l’erreur vient de notre côté. Réessayez dans un instant.",
          },
        },
        contractsDeleted: "Contrats supprimés",
        reminderSent: "Rappel envoyé",
        signerRemoved: "Signataire retiré",
        fieldRemoved: "Champ retiré",
        itemRemoved: "Poste supprimé",
        itemsRemoved: "Postes supprimés",
        scheduledPaymentRemoved: "Paiement planifié supprimé",
        scheduledPaymentCancelled: "Paiement planifié annulé",
        invoiceGenerated: "Facture générée",
      },
      forms: {
        rowLabel: "le formulaire {{name}}",
        back: "Retour",
        formActions: "Actions du formulaire",
        addQuestion: "Ajouter une question",
        addQuestionDropdownLabel:
          "Ajouter une question - Choisir le type de question",
        openFormInBrowser: "Ouvrir le formulaire dans le navigateur",
        formNeedsToBePublished:
          "Le formulaire doit être publié avant de pouvoir être ouvert dans le navigateur.",
        tabsLabel: "Onglets des détails du formulaire",
        tabBuilder: "Constructeur",
        tabResponses: "Réponses",
        responsesComingSoon: "Les réponses arrivent bientôt.",
        questionTypes: {
          text: "Texte",
          textarea: "Texte descriptif",
          single_select_radio: "Sélection unique (bouton radio)",
          multi_select_checkbox: "Sélection multiple (case à cocher)",
          file: "Téléversement de fichier",
          image: "Téléversement d'image",
        },
      },
      clients: {
        rowLabel: "le client {{name}}",
      },
      transactions: {
        transactionActions: "Actions de la transaction",
        rowLabel:
          "la transaction de {{amount}} du {{date}} pour la facture {{invoice}}",
      },
      timeEntries: {
        addTimeEntry: "Ajouter une entrée de temps",
        rowLabel: "l'entrée de temps pour {{project}} le {{date}} ({{detail}})",
        timeLoggedTitle: "Temps enregistré",
        draft: "Brouillon",
        createSuccess: "Entrée de temps créée avec succès",
        downloadCsv: "Télécharger le CSV",
        exportError:
          "Désolé, cette exportation n'a pas pu être générée en raison d'une erreur de notre côté. Veuillez réessayer plus tard.",
        funConfirmations: {
          "1": "Tu es génial(e) — temps enregistré.",
          "2": "Et voilà — encore une au compteur.",
          "3": "Noté. Le toi de demain te remercie.",
          "4": "Temps capturé. En avant !",
          "5": "Regarde-toi, toujours au top.",
          "6": "Parfait. Ce sera utile à la facturation.",
          "7": "Enregistré. Offre-toi un café.",
          "8": "Et hop, ces minutes sont dans la boîte.",
          "9": "Sauvegardé. Ta future facture te dit merci.",
          "10": "Temps bien suivi.",
        },
      },
      expenses: {
        addExpense: "Ajouter une dépense",
        markReviewed: "Marquer comme examinée",
        reopenDraft: "Rouvrir comme brouillon",
        rowLabel: "la dépense {{name}} du {{date}}",
        attachmentProcessed: "Reçu lu. Des champs ont peut-être été remplis.",
        attachmentProcessingFailed: "Le reçu n'a pas pu être lu.",
        currency: "Devise",
        invoiced: "facturée",
        statusDraft: "brouillon",
        bulk: {
          addToInvoice: "Ajouter à une facture existante",
          oneClient:
            "Choisissez des dépenses d'un seul client — une facture appartient à un seul client.",
          notInvoiceable:
            "Seules les dépenses enregistrées, non facturées et dans une même devise peuvent être ajoutées à une facture.",
          chooseInvoice: {
            title: "Choisir une facture",
            subtitle: "Factures brouillon pour {{client}}, en {{currency}}.",
            empty: "Aucune facture brouillon pour ce client.",
            itemCount_one: "{{count}} ligne",
            itemCount_other: "{{count}} lignes",
          },
          append: "Ajouter à {{number}}",
        },
      },
      products: {
        rowLabel: "le produit {{name}}",
        products: "Produits",
        product: "Produit",
        newProduct: "Nouveau produit",
        columns: {
          name: "Nom",
          sku: "UGS",
          unitPrice: "Prix",
          is_archived: "Statut",
          actions: "Actions",
        },
        active: "Actif",
        archived: "Archivé",
        showArchived: "Afficher les archivés",
        searchPlaceholder: "Rechercher par nom ou UGS",
        form: {
          name: "Nom",
          sku: "UGS",
          skuPlaceholder: "Facultatif",
          description: "Description",
          unitPrice: "Prix",
          currency: "Devise",
          currencyPlaceholder: "Sélectionnez une devise...",
          nameRequired: "Entrez un nom de produit.",
          currencyRequired: "Sélectionnez une devise.",
          priceInvalid: "Entrez un prix de zéro ou plus.",
          submitCreate: "Créer le produit",
          submitUpdate: "Enregistrer les modifications",
          saving: "Enregistrement du produit...",
          saveFailedTitle: "Le produit n’a pas été enregistré",
          saveFailed:
            "Désolé, ce produit n’a pas pu être enregistré en raison d’une erreur de notre côté. Veuillez réessayer plus tard.",
          saveForbidden:
            "Vous n’avez plus la permission de modifier les produits.",
          saveNotFound:
            "Ce produit n’existe plus. Il a peut-être été supprimé.",
        },
        modal: {
          createTitle: "Nouveau produit",
          createDescription:
            "Ajoutez un article ou un service à votre liste de prix.",
          editTitle: "Modifier le produit",
          editDescription: "Mettez à jour cet article de votre liste de prix.",
        },
        create: {
          submitting: "Création du produit...",
          created: "Produit créé avec succès",
          createdMessage:
            "Il est prêt à être ajouté aux factures et aux contrats.",
        },
        rowActions: {
          menuLabel: "Actions du produit",
          edit: "Modifier",
          archive: "Archiver",
          unarchive: "Désarchiver",
        },
        empty: {
          title: "Aucun produit pour le moment",
          subtitle:
            "Ajoutez ce que votre organisation vend, puis réutilisez-le sur les factures et les contrats.",
          create: "Créer un produit",
          import: "Importer depuis un CSV",
        },
        confirmDeleteTitle: "Supprimer le produit",
        confirmDeleteTitle_plural: "Supprimer les produits",
        confirmDeleteMessage: "Êtes-vous sûr de vouloir supprimer ce produit?",
        confirmDeleteMessage_plural:
          "Êtes-vous sûr de vouloir supprimer ces {{count}} produits?",
        productArchived: "Produit archivé avec succès",
        productUnarchived: "Produit désarchivé avec succès",
        productsDeleted: "Produits supprimés avec succès",
      },
      invoices: {
        sourceSelectionDescription:
          "Comment souhaitez-vous créer cette facture ?",
        selectClient: "Sélectionner un client",
        filterTimeEntries: "Filtrer les entrées de temps",
        selectGrouping: "Comment regrouper les lignes ?",
        wizardStepBasics: "Éléments de base",
        wizardStepSchedule: "Calendrier",
        wizardStepSourceItems: "Source et éléments",
        wizardStepFeesTaxes: "Frais et taxes",
        createError: "Échec de la création de la facture. Veuillez réessayer.",
        noMatchingEntries:
          "Aucune entrée de temps ne correspond aux filtres actuels",
        wizard: {
          stepsLabel: "Étapes",
          stepSource: "Source",
          stepClient: "Client",
          stepFilters: "Filtres",
          stepGrouping: "Regroupement",
          detailsHeading: "Détails de la facture",
          searchClients: "Rechercher des clients",
          previewCount_one:
            "1 entrée de temps correspond. Suivant est disponible.",
          previewCount_other:
            "{{count}} entrées de temps correspondent. Suivant est disponible.",
          creating: "Création de la facture…",
          saving: "Enregistrement de la facture récurrente…",
          deleteNamed: "Supprimer {{name}}",
          itemNumbered: "Élément {{n}}",
          discountNumbered: "Remise {{n}}",
        },
        rowLabel: "la facture {{number}}",
        recurringRowLabel: "la facture récurrente {{name}}",
        downloadCsv: "Télécharger le CSV",
        exportError:
          "Désolé, cette exportation n'a pas pu être générée en raison d'une erreur de notre côté. Veuillez réessayer plus tard.",
        fromContract: "Provenant du contrat",
        generatedFromContract: "Générée à partir du contrat {{number}}",
        generatedFromAContract: "Générée à partir d’un contrat",
        uploadInvoiceLogo: "Téléverser le logo de la facture",
        deleteInvoiceLogo: "Supprimer le logo de la facture",
        addExpenses: {
          toastSuccess: "Dépenses ajoutées à la facture.",
        },
        canvas: {
          addExpensesTrigger: "Ajouter des dépenses",
          addTaxNonTaxableHint:
            "Cette ligne n'est pas taxable — le montant de la dépense inclut déjà la taxe payée.",
          fromExpenses: "Depuis les dépenses du client",
          expenseSource: "dépense",
          addExpenses: {
            title: "Ajouter des dépenses",
            subtitle: "Dépenses facturables pour {{client}}, en {{currency}}.",
            filterProject: "Projet",
            filterProjectAll: "Tous les projets",
            filterFrom: "Du",
            filterTo: "Au",
            currencyNote: "Seules les dépenses en {{currency}} sont affichées.",
            currencyNoteFx: "Les autres devises arriveront bientôt.",
            hiddenCount_one:
              "{{count}} dépense dans une autre devise est masquée.",
            hiddenCount_other:
              "{{count}} dépenses dans d'autres devises sont masquées.",
            colVendor: "Fournisseur",
            colDate: "Date",
            colAmount: "Montant",
            selectAll: "Tout sélectionner",
            receipts_one: "{{count}} reçu",
            receipts_other: "{{count}} reçus",
            taxable: "Taxable",
            taxableHint:
              "Appliquer les taxes de cette facture aux lignes ajoutées.",
            includeReceipts: "Inclure les reçus",
            includeReceiptsHint:
              "Joindre les reçus de chaque dépense à la facture.",
            selected: "{{count}} sélectionnée(s)",
            empty: "Aucune dépense facturable pour ce client.",
            emptyFiltered: "Aucune dépense ne correspond à ces filtres.",
            loading: "Chargement des dépenses…",
            confirm_one: "Ajouter {{count}} dépense",
            confirm_other: "Ajouter {{count}} dépenses",
            confirmEmpty: "Ajouter des dépenses",
            toastAdded_one: "{{count}} dépense ajoutée à la facture.",
            toastAdded_other: "{{count}} dépenses ajoutées à la facture.",
            fxHeld:
              "Seules les dépenses en {{currency}} peuvent être facturées pour l'instant — la conversion de devises n'est pas encore active.",
          },
        },
        groupingByEntry: "Par entrée de temps",
        useTimeEntryDescription:
          "Inclure les descriptions des entrées de temps",
        recurringInvoiceStatus: {
          active: "Active",
          paused: "En pause",
          archived: "Archivée",
        },
        recurringInvoiceActions: {
          pause: "Mettre en pause",
          resume: "Reprendre",
          archive: "Archiver",
          restore: "Restaurer",
          delete: "Supprimer",
        },
        recurringInvoiceViews: {
          main: "Principale",
          archived: "Archivées",
        },
        recurringInvoiceBulk: {
          pauseSelected: "Mettre en pause la sélection",
          archiveSelected: "Archiver la sélection",
          restoreSelected: "Restaurer la sélection",
          deleteSelected: "Supprimer la sélection",
        },
        recurringInvoiceDeleteConfirmationDynamicMessage_one:
          "Supprimer définitivement 1 facture récurrente ? Cette action est irréversible.",
        recurringInvoiceDeleteConfirmationDynamicMessage_other:
          "Supprimer définitivement {{count}} factures récurrentes ? Cette action est irréversible.",
        recurringInvoiceLifecycleSuccess_pause_one:
          "1 facture récurrente mise en pause.",
        recurringInvoiceLifecycleSuccess_pause_other:
          "{{count}} factures récurrentes mises en pause.",
        recurringInvoiceLifecycleSuccess_resume_one:
          "1 facture récurrente reprise.",
        recurringInvoiceLifecycleSuccess_resume_other:
          "{{count}} factures récurrentes reprises.",
        recurringInvoiceLifecycleSuccess_archive_one:
          "1 facture récurrente archivée.",
        recurringInvoiceLifecycleSuccess_archive_other:
          "{{count}} factures récurrentes archivées.",
        recurringInvoiceLifecycleSuccess_restore_one:
          "1 facture récurrente restaurée.",
        recurringInvoiceLifecycleSuccess_restore_other:
          "{{count}} factures récurrentes restaurées.",
        recurringInvoiceLifecycleSkipped_one: "{{count}} élément ignoré.",
        recurringInvoiceLifecycleSkipped_other: "{{count}} éléments ignorés.",
        recurringInvoiceLifecycleNoneUpdated:
          "Rien à faire — tous les éléments sélectionnés sont déjà dans cet état.",
        recurringInvoiceEmptyMain:
          "Aucune facture récurrente active ou en pause.",
        recurringInvoiceEmptyArchived: "Aucune facture récurrente archivée.",
        invoiceLeadDaysLabel: "Générer ce nombre de jours à l'avance",
        invoiceLeadDaysHelper:
          "Nombre de jours avant la date prévue où la prochaine facture doit être créée. Par défaut 7. Plage 0 à 90.",
        convertToRecurring: "Transformer en facture récurrente",
        sendReminder: "Envoyer un rappel",
        sendReminderConfirmation:
          "Envoyer un rappel de paiement au client pour cette facture ? Il recevra un courriel avec un lien pour payer.",
        sendReminderSuccess: "Rappel envoyé.",
        sendReminderNotSent:
          "Cette facture n'a pas encore été envoyée; un rappel ne peut donc pas être envoyé. Envoyez d'abord la facture.",
        sendReminderAlreadyPaid:
          "Cette facture est déjà payée; il n'y a aucun rappel à envoyer.",
        manualInvoiceReminder: "Rappel manuel",
        manualReminderInfo:
          "Le message envoyé lorsque vous envoyez manuellement un rappel depuis une facture. Les rappels manuels sont envoyés à la demande, en dehors du calendrier automatique ci-dessus.",
        convertPrefillBannerTitle: "Certains champs n'ont pas pu être repris",
        convertPrefillLoading: "Chargement de la facture source…",
      },
    },
    settings: {
      profile: {
        mcpConnections: mcpConnectionsFrCA,
      },
      integrations: {
        mcp: mcpFrCA,
        overview: "Aperçu",
        howItWorks: "Fonctionnement",
        slackWorkspaceTaken:
          "Cet espace de travail Slack est déjà connecté à une autre organisation.",
        slackConnectionCancelled: "La connexion à Slack a été annulée.",
      },
      customFields: {
        rowLabel: "le champ personnalisé {{name}}",
      },
      billing: {
        billing: "Facturation",
      },
      customerEmail: {
        pageTitle: "Courriel client",
      },
      expensesInbound: {
        address: {
          copiedTooltip: "Copié",
        },
      },
      senderDomain: {
        dnsRecords: {
          copied: "Copié",
        },
      },
      expenseBudgets: {
        currency: "Devise",
      },
      invoices: {
        contractInvoiceLeadTime: {
          label: "Délai d'émission des factures de contrat",
          help: "Utilisé par chaque contrat et chaque paiement qui n'a pas son propre délai, et relu chaque fois qu'une date de facturation est calculée — le modifier déplace donc aussi les paiements des contrats déjà signés mais pas encore facturés. Réglez-le à 0 pour émettre les factures le jour même de l'échéance, ce qui ne laisse au client aucun délai pour payer avant la date limite.",
          fieldLabel:
            "Envoyer les factures de contrat ce nombre de jours avant l'échéance du paiement",
          fieldHelper: "Valeur par défaut : 7. Plage : de 0 à 365.",
          rangeError: "Saisissez un nombre entier de jours entre 0 et 365.",
          requiredError:
            "Le délai d'émission des factures de contrat est requis.",
          saved:
            "Délai d'émission des factures de contrat mis à jour avec succès",
          serverError:
            "Désolé, ce paramètre n'a pas pu être enregistré en raison d'une erreur de notre côté. Veuillez réessayer plus tard.",
        },
      },
      services: {
        rowLabel: "le service {{name}}",
        serviceActions: "Actions du service",
        archiveService: "Archiver",
        unarchiveService: "Désarchiver",
        deleteService: "Supprimer",
      },
      organization: {
        editTitle: "Modifier l'organisation",
        tabs: {
          general: "Général",
          team: "Équipe",
          roles: "Rôles",
          notifications: "Notifications",
        },
        owner: "Propriétaire",
        editMember: {
          ownerTransferWarning:
            "Vous deviendrez administrateur dans {{organization}}. Cette action est immédiate.",
          ownerTransferTypeNamePrompt: "Tapez {{name}} pour confirmer.",
          ownerTransferNameMismatch:
            "Le nom de confirmation ne correspond pas.",
          transferOwnership: "Transférer la propriété",
          ownerTransferSuccess: "Propriété transférée à {{name}}.",
        },
        invitations: {
          heading: "Invitations",
          invitedAt: "Invitée le",
          inviter: "Invitée par",
          selectAll: "Sélectionner toutes les invitations de cette page",
          selectRow: "Sélectionner l'invitation pour {{email}}",
          deleteSelected: "Supprimer {{count}} invitations",
          pageOf: "Page {{current}} sur {{total}}",
          previous: "Précédent",
          next: "Suivant",
          filter: {
            label: "Filtrer par statut",
            all: "Toutes",
            pending: "En attente",
            expired: "Expirées",
            accepted: "Acceptées",
            declined: "Refusées",
            cancelled: "Annulées",
          },
          statusLabel: {
            pending: "En attente",
            expired: "Expirée",
            accepted: "Acceptée",
            declined: "Refusée",
            cancelled: "Annulée",
          },
          actions: {
            menuLabel: "Actions de l'invitation pour {{email}}",
            resend: "Renvoyer",
            changeRole: "Modifier le rôle",
            cancel: "Annuler",
            delete: "Supprimer",
          },
          changeRole: {
            title: "Modifier le rôle de l'invitation",
            description:
              "Choisissez un nouveau rôle pour l'invitation envoyée à {{email}}.",
            submit: "Mettre à jour le rôle",
            successToast: "Rôle de l'invitation mis à jour.",
          },
          empty: {
            pending: "Aucune invitation en attente.",
            expired: "Aucune invitation expirée.",
            accepted: "Aucune invitation acceptée.",
            declined: "Aucune invitation refusée.",
            cancelled: "Aucune invitation annulée.",
          },
          emptyAll: "Aucune invitation pour le moment.",
          cancelTitle: "Annuler l'invitation",
          cancelMessage:
            "Annuler l'invitation envoyée à {{email}}? Le destinataire ne pourra plus l'accepter.",
          confirmCancel: "Annuler l'invitation",
          deleteTitle: "Supprimer l'invitation",
          deleteMessage:
            "Supprimer l'invitation envoyée à {{email}}? Cette action est irréversible.",
          bulkDeleteTitle: "Supprimer les invitations",
          bulkDeleteMessage:
            "Supprimer {{count}} invitations? Cette action est irréversible.",
          confirmDelete: "Supprimer",
        },
        roles: {
          groupSystem: "Système",
          groupCustom: "Personnalisé",
          pageTitle: "Rôles",
          pageDescription:
            "Les rôles définissent ce que vos membres peuvent faire. Les rôles système sont intégrés; créez des rôles personnalisés pour affiner les accès.",
          createButton: "Créer un rôle",
          createButtonDisabledTooltip:
            "Passez à Pro pour créer des rôles personnalisés.",
          columnName: "Nom",
          columnMembers: "Membres",
          columnSystem: "Type",
          columnDescription: "Description",
          systemTooltip: "Rôle système — ne peut pas être modifié ou supprimé.",
          customBadge: "Personnalisé",
          upgradeCardHeadline: "Créez des rôles personnalisés",
          upgradeCardBody:
            "Définissez des rôles avec des permissions granulaires adaptées au fonctionnement de votre équipe. Disponible avec le forfait Pro.",
          upgradeCardCta: "Passer à Pro",
          rowEditAction: "Modifier le rôle",
          rowDeleteAction: "Supprimer le rôle",
          loading: "Chargement des rôles…",
          emptyTitle: "Aucun rôle pour le moment",
          emptyMessage: "Créez un rôle personnalisé pour commencer.",
          deleteModalTitle: "Supprimer le rôle",
          deleteModalMessage:
            "Supprimer le rôle {{name}}? Cette action est irréversible.",
          deleteConfirmButton: "Supprimer",
          blockedModalTitle: "Rôle utilisé",
          blockedModalMessage:
            "Le rôle {{name}} est attribué à {{memberCount}} membre(s) et à {{invitationCount}} invitation(s) en attente. Réaffectez-les avant de supprimer.",
          blockedModalCta: "Aller à la page de l’équipe",
          form: {
            createTitle: "Créer un rôle",
            editTitle: "Modifier le rôle",
            back: "Retour",
            nameLabel: "Nom",
            namePlaceholder: "p. ex. Responsable de la facturation",
            descriptionLabel: "Description",
            descriptionPlaceholder: "À quoi sert ce rôle?",
            permissionsLabel: "Permissions",
            permissionsHelp:
              "Choisissez ce que les membres ayant ce rôle peuvent faire. Sélectionner une action accorde automatiquement l’accès en consultation correspondant.",
            selectedCounter: "{{selected}} sur {{total}} sélectionné(s)",
            atLeastOne: "Sélectionnez au moins une permission.",
            loading: "Chargement des permissions…",
            createSubmit: "Créer le rôle",
            editSubmit: "Enregistrer les modifications",
            createSuccess: "Rôle créé.",
            updateSuccess: "Rôle mis à jour.",
          },
        },
        notifications: {
          title: "Acheminement des notifications",
          description:
            "Choisissez qui reçoit chaque notification d'invup concernant cette organisation. Laissez une règle vide pour utiliser la valeur par défaut : le propriétaire et les administrateurs de l'organisation.",
          save: "Enregistrer les modifications",
          cancel: "Annuler",
          saved: "Acheminement des notifications enregistré",
          addEmailPlaceholder: "Ajouter un courriel…",
          defaultBadge: "Par défaut : propriétaire + administrateurs",
          footerNote:
            "Appuyez sur Entrée ou sur la virgule pour ajouter chaque destinataire.",
          invalidEmail: "Saisissez une adresse courriel valide.",
          duplicate: "« {{email}} » est déjà un destinataire.",
          duplicateNotificationType:
            "Chaque notification ne peut être configurée qu'une seule fois par organisation.",
          groups: {
            invoices: "Factures",
            payments: "Paiements",
            forms: "Formulaires",
            integrations: "Intégrations",
          },
          types: {
            invoice_sent: {
              label: "Facture envoyée",
              description:
                "Lorsqu'une facture est envoyée à un client (manuellement ou selon un horaire).",
            },
            invoice_paid: {
              label: "Facture payée",
              description:
                "Lorsqu'un client paie une facture et qu'une transaction est enregistrée.",
            },
            recurring_invoice_created: {
              label: "Facture récurrente créée",
              description:
                "Lorsqu'une nouvelle facture est générée à partir d'un horaire récurrent.",
            },
            contract_invoice_generated: {
              label: "Facture de contrat générée",
              description:
                "Lorsqu'une facture est générée à partir de l'échéancier de paiement d'un contrat.",
            },
            transaction_receipt: {
              label: "Reçu de transaction",
              description:
                "En copie conforme du courriel de reçu envoyé au client lorsqu'il paie une facture.",
            },
            form_submitted: {
              label: "Réponse au formulaire soumise",
              description:
                "Lorsqu'un client soumet une réponse à l'un de vos formulaires.",
            },
            slack_reconnect_needed: {
              label: "Reconnexion Slack requise",
              description:
                "Lorsque votre connexion Slack n’a pas les autorisations requises par une fonctionnalité. Envoyé chaque semaine, jusqu’à quatre fois, jusqu’à ce que quelqu’un la reconnecte.",
            },
          },
        },
      },
      reportSubscriptions: {
        rowLabel: "l'abonnement au rapport {{name}}",
        title: "Abonnements aux rapports",
        titleSingular: "Abonnement au rapport",
        subtitle:
          "Planifiez l'envoi récurrent de rapports de temps vers Slack.",

        create: "Nouvel abonnement",
        edit: "Modifier",
        delete: "Supprimer",
        runNow: "Exécuter",
        enable: "Activer",
        disable: "Désactiver",
        save: "Enregistrer",
        cancel: "Annuler",

        name: "Nom",
        schedule: "Horaire",
        destination: "Destination",
        groupedBy: "Regroupé par",
        period: "Période",
        status: "Statut",
        lastRun: "Dernière exécution",
        lastSuccess: "Dernier envoi",
        never: "Jamais",
        failures: "Échecs consécutifs",

        nameLabel: "Nom",
        namePlaceholder: "p. ex. Heures hebdomadaires par client",
        groupByLabel: "Regrouper par",
        groupBySecondaryLabel: "Puis regrouper par",
        groupBySecondaryHelp: "Niveau de regroupement secondaire (facultatif).",
        filtersLabel: "Filtres",
        filtersHelp: "Laissez un filtre vide pour tout inclure.",
        clientsLabel: "Clients",
        projectsLabel: "Projets",
        servicesLabel: "Services",
        membersLabel: "Membres",
        periodTypeLabel: "Type de période",
        periodTypeHelp:
          "La période civile couvre une plage nommée; la fenêtre glissante couvre les N derniers jours, semaines ou mois.",
        calendarPeriodLabel: "Période civile",
        windowUnitLabel: "Unité de la fenêtre",
        windowLengthLabel: "Longueur de la fenêtre",
        windowLengthHelp:
          "Combien d'unités ci-dessus inclure, p. ex. les 4 dernières semaines.",
        frequencyLabel: "Fréquence",
        dayOfWeekLabel: "Jour de la semaine",
        timeOfDayLabel: "Heure de la journée",
        timezoneNote:
          "Les envois utilisent le fuseau horaire de votre organisation ({{timezone}}).",
        timezoneSettingsLink:
          "Modifiez-le dans les paramètres de l'organisation.",
        channelLabel: "Canal Slack",
        channelIdLabel: "ID du canal",
        channelNameLabel: "Nom du canal",
        destinationHelp: "Les rapports sont publiés dans ce canal Slack.",

        dimension: {
          client: "Client",
          project: "Projet",
          member: "Membre",
          service: "Service",
        },
        periodType: {
          calendar: "Période civile",
          rolling: "Fenêtre glissante",
        },
        calendarPeriod: {
          this_week: "Cette semaine",
          month_to_date: "Mois à ce jour",
          last_week: "La semaine dernière",
          last_month: "Le mois dernier",
        },
        rollingUnit: {
          days: "Jours",
          weeks: "Semaines",
          months: "Mois",
        },
        frequency: {
          daily: "Quotidienne",
          weekly: "Hebdomadaire",
        },

        activeBadge: "Actif",
        disabledBadge: "Désactivé",
        pausedBadge: "Suspendu",
        pausedReason: {
          scope_lost:
            "Suspendu — vous n'avez plus accès aux données couvertes par ce rapport.",
          owner_inactive:
            "Suspendu — le propriétaire n'est plus actif dans cette organisation.",
          too_many_failures:
            "Suspendu — l'envoi a échoué plusieurs fois de suite.",
        },

        emptyTitle: "Aucun abonnement aux rapports pour l'instant",
        emptyMessage:
          "Créez un abonnement pour recevoir des rapports de temps planifiés dans Slack.",

        deleteSuccess: "Abonnements aux rapports supprimés",
        runNowSuccess: "Rapport en file d'attente — il sera livré sous peu.",
        enabledSuccess: "Abonnement au rapport activé",
        disabledSuccess: "Abonnement au rapport désactivé",

        addTitle: "Nouvel abonnement au rapport",
        editTitle: "Modifier l'abonnement au rapport",

        sectionWhat: "Quoi rapporter",
        sectionWhen: "Quand envoyer",
        sectionWhere: "Où envoyer",

        groupBySecondaryNone: "Aucun",
        selectPlaceholder: "Sélectionner…",

        channelIdPlaceholder: "p. ex. C0123ABCD",
        channelNamePlaceholder: "p. ex. #finance",
        channelIdHelp:
          "Dans Slack, ouvrez le canal → À propos → copiez l'ID du canal. Invup doit être membre du canal.",

        dayOfWeek: {
          "1": "Lundi",
          "2": "Mardi",
          "3": "Mercredi",
          "4": "Jeudi",
          "5": "Vendredi",
          "6": "Samedi",
          "7": "Dimanche",
        },

        scheduleDaily: "Tous les jours à {{time}}",
        scheduleWeekly: "{{day}} à {{time}}",
        rollingSummary: "{{count}} {{unit}}",

        enabledFilterLabel: "Activé",

        confirmDeleteTitle: "Supprimer l'abonnement ?",
        confirmDeleteTitle_plural: "Supprimer les abonnements ?",
        confirmDeleteMessage:
          "Cette action supprime définitivement l'abonnement. Elle est irréversible.",
        confirmDeleteMessage_plural:
          "Cette action supprime définitivement {{count}} abonnements. Elle est irréversible.",
        deleteError: "Impossible de supprimer les abonnements.",

        secondaryMustDiffer:
          "Le regroupement secondaire doit différer du regroupement principal.",
        rollingCountRange: "Entrez un nombre de 1 à {{max}}.",
        nameMaxLength: "Le nom ne doit pas dépasser 255 caractères.",
      },
    },
  },
  global: {
    addressLineOne: "Adresse Ligne Un",
    addressLineTwo: "Adresse Ligne Deux",
    back: "Retour",
    city: "Ville",
    country: "Pays",
    email: "E-mail",
    invupme: "invup",
    invoice: "Facture",
    maxLengthFieldErrorMessage:
      "Ce champ a dépassé la longueur maximale de caractères.",
    maxLengthWithValueFieldErrorMessage:
      "Ce champ ne peut accepter que {{value}} caractères.",
    name: "Nom",
    patternFieldErrorMessage: "Ce champ ne correspond pas au modèle requis.",
    phoneNumber: "Téléphone",
    requiredFieldErrorMessage: "{{value}} est requis.",
    continue: "Continuer",
    state: "État/Province",
    tagLine: "Slogan",
    zipCode: "Code postal",
    weSentYouAPasscode: "Nous vous avons envoyé un e-mail avec un code d'accès",
    organizationName: "Nom de l'organisation",
  },
  login: {
    welcomeBack: "Connectez-vous à Invup",
    pleaseProvideEmail:
      "Veuillez fournir votre adresse e-mail pour vous connecter",
    createNewAccount: "Créer un nouveau compte",
  },
  signup: {
    welcomeToInvup: "Bienvenue sur Invup",
    pleaseProvideEmail:
      "Veuillez fournir votre adresse e-mail pour créer un compte",
    useExitingAccount: "Connectez-vous avec un compte existant",
  },
  newOrganization: {
    getStartedTitle: "Commençons",
    getStartedMessage: "Créez votre première organisation pour commencer !",
    createOrganization: "Créer une organisation",
    createNewOrganizationTitle: "Créer une nouvelle organisation",
    createNewOrganizationMessage:
      "Ajoutez une autre organisation à votre compte",
  },
  timeline: {
    empty: "Aucune activité pour le moment",
    relative: {
      now: "à l'instant",
      minutes: "il y a {{count}} min",
      hours: "il y a {{count}} h",
      days: "il y a {{count}} j",
      weeks: "il y a {{count}} sem.",
      months: "il y a {{count}} mois",
    },
    feedLabel_one: "Chronologie de l'activité, {{count}} événement",
    feedLabel_many: "Chronologie de l'activité, {{count}} événements",
    feedLabel_other: "Chronologie de l'activité, {{count}} événements",
    announce: {
      range_one: "Affichage de l'événement {{start}}.",
      range_many: "Affichage des événements {{start}} à {{end}}.",
      range_other: "Affichage des événements {{start}} à {{end}}.",
      rangeOfTotal_one: "Affichage de l'événement {{start}} sur {{total}}.",
      rangeOfTotal_many:
        "Affichage des événements {{start}} à {{end}} sur {{total}}.",
      rangeOfTotal_other:
        "Affichage des événements {{start}} à {{end}} sur {{total}}.",
      results_one: "{{count}} événement trouvé.",
      results_many: "{{count}} événements trouvés.",
      results_other: "{{count}} événements trouvés.",
      resultsMore_one:
        "Affichage du premier événement; d'autres sont disponibles.",
      resultsMore_many:
        "Affichage des {{count}} premiers événements; d'autres sont disponibles.",
      resultsMore_other:
        "Affichage des {{count}} premiers événements; d'autres sont disponibles.",
      noMatches: "Aucun événement ne correspond à ces dates.",
      loadFailed: "L'activité n'a pas pu être chargée.",
      refreshed: "Activité actualisée.",
      refreshedNew_one: "Activité actualisée. {{count}} nouvel événement.",
      refreshedNew_many: "Activité actualisée. {{count}} nouveaux événements.",
      refreshedNew_other: "Activité actualisée. {{count}} nouveaux événements.",
      refreshedNoChange: "Activité actualisée. Rien n'a changé.",
      refreshFailed: "L'activité n'a pas pu être actualisée.",
    },
    loading: "Chargement…",
    refresh: "Actualiser l'activité",
    filters: {
      from: "Du",
      to: "Au",
      reset: "Réinitialiser",
    },
    pagination: {
      previous: "Précédent",
      next: "Suivant",
    },
  },
  activity: {
    title: "Activité",
    description:
      "Une chronologie des modifications dans cette organisation — qui a fait quoi, et quand.",
  },
  teamMemberDetails: {
    activityHeading: "Activité",
  },
  successfulTeamMemberInvitationResend: "Invitation renvoyée",
  successfulTeamMemberInvitationCancel: "Invitation annulée",
  successfulTeamMemberInvitationDelete: "Invitation supprimée",
  successfulTeamMemberInvitationsBulkDelete: "Invitations supprimées",
  successfulRoleDelete: "Rôle supprimé",
  ...rayaLucariaFrCA,
};
